/**
 * Formats a date/timestamp to DD-MM-YYYY HH:mm:ss format (24-hour clock)
 * @param timestamp - Date, number (milliseconds), or string that can be parsed as a date
 * @returns Formatted date string in DD-MM-YYYY HH:mm:ss format
 */
export const dateToStringFormat = (timestamp: number | string | Date): string => {
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

/**
 * Formats a date to DD-MM-YYYY HH:mm:ss format (24-hour clock) for DataGrid valueFormatter
 * @param value - Date object or null/undefined
 * @returns Formatted date string or 'N/A' if value is invalid
 */
export const formatDateDDMMYYYY = (value: Date | null | undefined): string => {
  if (!value || !(value instanceof Date) || isNaN(value.getTime())) {
    return 'N/A';
  }
  return dateToStringFormat(value);
};
